<template>
  <button @click="toggle" :aria-label="ariaLabel">
    <v-icon v-if="course.isFavorite" color="favoriteStar">
      mdi-star
    </v-icon>
    <v-icon v-else>
      mdi-star-outline
    </v-icon>
  </button>
</template>

<script>
  import { mapActions } from "vuex";

  export default {
    name: "FavoriteButton",
    props: {
      course: { type: Object, required: true },
    },
    methods: {
      ...mapActions(['toggleFavorite']),
      toggle(){
        this.toggleFavorite(this.course)
      }
    },
    computed: {
      ariaLabel() {
        const action = this.course.isFavorite ? 'remove' : 'add'
        return this.$t(
            `course.favorite.ariaLabel.${action}`,
            {courseName: this.course.shortName}
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
